import {
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormNumberFieldWithLabel,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";

// import { RHookFormDatePicker } from "../../RHookFormDatePicker";

interface IEmployeeAdditionalInformationFieldsPanel extends ITest {
	formMethods: any;
}
export let provinceResponce: any = undefined;
export const EmployeeAdditionalInformationFieldsPanel: FC<
	IEmployeeAdditionalInformationFieldsPanel
> = ({ formMethods }) => {
	// const [showRegularDailyHours, setShowRegularDailyHours] = useState(200)
	const employeePayrollType = formMethods.watch("employeePayrollType") ?? 200;
	return (
		<>
			<RHookFormDatePicker
				name="datePensionBecomePayable"
				testId="datePensionBecomePayable"
				label="Date Pension Becomes Payable"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<RHookFormTextFieldWithLabel
				label="RPP or DPSP Registration No."
				id="rppOrDpspRegistrationNumber"
				testId={`rppOrDpspRegistrationNumber`}
				labelPosition={LabelPosition.Top}
			/>
			<RHookFormDatePicker
				name="dateOfDisability"
				testId="dateOfDisability"
				label="Date of Disability"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<RHookFormDatePicker
				name="dateDisabilityWasCeased"
				testId="dateDisabilityWasCeased"
				label="Date Disability was Ceased"
				labelPosition={LabelPosition.Top}
				format="M dd, yy"
				// required
				labelColumns={4}
				fieldColumns={8}
			/>
			<EnhancedDropDownRHFWithLabel
				selectName="employeePayrollType"
				label="Employee Payroll"
				testId={`employee_payroll_type`}
				items={[
					{ label: "Regular", value: 200 },
					{ label: "Irregular", value: 100 },
				]}
				// selectedItem={200}
				selectedItem={employeePayrollType}
			// onSelectionChangeHandler={(e: any) => setShowRegularDailyHours(e.value)}
			/>
			{employeePayrollType === 200 && <RHookFormNumberFieldWithLabel
				id="regularDailyHours"
				label="Regular daily hours for employees"
				testId={`regular_daily_hours`}
			/>}
		</>
	);
};
